type SpectrumIconProps = {
  width?: string;
  height?: string;
  marginBottom?: string;
}

export function SpectrumIcon(props: SpectrumIconProps) {
  const { width = null, height = null, marginBottom = null } = props;
  const style = {
    width: width ?? '1.5em',
    height: height ?? '1.5em',
    marginBottom: marginBottom ?? undefined,
    fill: 'currentColor'
  };
  return (
    <svg style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64" role="img" aria-label="Voice spectrum">
      <rect style={{fill: 'currentcolor'}} x="14" y="26" width="6" height="12" rx="3">
        <animate attributeName="height" values="10;26;14;30;12;22;10" dur="2.9s" repeatCount="indefinite"/>
        <animate attributeName="y"      values="27;19;25;17;26;21;27" dur="2.9s" repeatCount="indefinite"/>
      </rect>

      <rect style={{fill: 'currentcolor'}} x="24" y="22" width="6" height="20" rx="3">
        <animate attributeName="height" values="16;34;22;40;18;30;16" dur="2.78s" repeatCount="indefinite"/>
        <animate attributeName="y"      values="24;15;21;12;23;17;24" dur="2.78s" repeatCount="indefinite"/>
      </rect>

      <rect style={{fill: 'currentcolor'}} x="34" y="22" width="6" height="20" rx="3">
        <animate attributeName="height" values="16;38;20;42;18;28;16" dur="2.82s" repeatCount="indefinite"/>
        <animate attributeName="y"      values="24;13;22;11;23;18;24" dur="2.82s" repeatCount="indefinite"/>
      </rect>

      <rect style={{fill: 'currentcolor'}} x="44" y="26" width="6" height="12" rx="3">
        <animate attributeName="height" values="10;28;14;32;12;20;10" dur="2.96s" repeatCount="indefinite"/>
        <animate attributeName="y"      values="27;18;25;16;26;22;27" dur="2.96s" repeatCount="indefinite"/>
      </rect>
    </svg>
  );
}
